<template>
  <div id="app">
    <cdu-wrapper></cdu-wrapper>
  </div>
</template>

<script>

  import CduWrapper from 'views/cdu/CduWrapper'

  import flexible from 'utils/flexible'

  export default{
    name: 'App',
    components: {
      CduWrapper
    },
    data() {
      return {
      }
    },
    created() {
    },
  }
</script>

<style>
  @import 'assets/css/base.css';

</style>
